import {Badge, type BadgeProps} from '@mantine/core'

export function OutOfStateBadge({
    label,
    ...props
}: {label: string | null | undefined} & Omit<BadgeProps, 'children'>) {
    if (!label) {
        return null
    }

    return (
        <Badge size="xs" variant="light" color="orange" data-testid="out-of-state-tag" {...props}>
            {label}
        </Badge>
    )
}
